import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useParams, useHistory } from 'react-router-dom'
import { DEFAULT_ROUTES_OBJ } from '../../../components/lhs/__mock'
import { LayoutHeaderMenu, TourGuide } from '../../../components'

import { ROLES_CLIENT_PRIMARY, ROLES_CLIENT_SECONDARY } from '../../../constants'

import reportsService from '../../../services/reports.service'
import { useGlobalStore } from '../../../store'
import { CanWeHelp } from '../../../components'
import PublishProject from '../../../layout/postLoginReportsV2/header/publish-project'

import { logo, Files, Settings, Info } from '../../../assets/images/icons'
import IconsWrapper from './iconWrapper'

import {
  OuterWrapper,
  SidebarContainer,
  MiddleSection,
  BottomSection,
  TopSection,
  LogoImage,
} from './style'

const Sidebar = ({ activePage, page }) => {
  // const rootRef = useRef(null)
  const { id } = useParams()
  const navigate = useHistory()
  const [selectedTab, setSelectedTab] = useState('')
  const [showCanWeHelpModal, setShowCanWeHelpModal] = useState(false)
  const { pathname, hash } = useLocation()
  // const reportsLhsData = DEFAULT_ROUTES
  const reportsLhsObject = DEFAULT_ROUTES_OBJ

  const { user, setSubLhs, setAskIaActiveState, isAskIaActiveState } = useGlobalStore()

  ////////////////////////////////////////////////////////
  const getSubHeadings = (tabId) => {
    // setSubTabsLoading(true)
    reportsService
      .reportTabsApi({ studyId: id, tabId })
      .then((resp) => {
        const lhsTabsRes = resp
          .sort((a, b) => a.InsightsElementOrder - b.InsightsElementOrder)
          .filter((t) => t.InsightsElementVisible)
          .map((list, i) => {
            list.active = false
            list.tabContent = null
            list.isApiLoading = true
            list.Title = (list?.Title).replaceAll(':', ' - ')
            return list
          })

        if (lhsTabsRes?.length > 0) {
          setSubLhs([...lhsTabsRes])
        }
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
      .finally(() => {
        // setSubTabsLoading(false)
      })
  }

  useEffect(() => {
    // if (selectedTab?.TabId && isreportpage) { // fixed lint issue
    //   getSubHeadings(selectedTab?.TabId)
    // }
  }, [selectedTab])

  const hideLhs = () => {
    // rootRef.current.classList.remove('show')
  }

  useEffect(() => {
    hideLhs()
  }, [pathname, hash])

  // Login Time checking // max 15 hours
  const hoursCheck = () => {
    const diff_hours = (dt2, dt1) => {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000
      diff /= 60 * 60
      return Math.abs(Math.round(diff))
    }
    const loginedInHours = diff_hours(new Date(user?.loginTime), new Date())
    if (loginedInHours >= 15) {
      localStorage.clear()
      navigate.push('/')
    }
  }

  const checkAskIaIsActiveFunc = () => {
    if (isAskIaActiveState !== 'none') {
      setAskIaActiveState('none')
    }
  }

  useEffect(() => {
    hoursCheck()
  }, [])

  ///////////////////////////////////////////////////////
  return (
    <OuterWrapper>
      <SidebarContainer>
        <TopSection>
          <LogoImage src={logo} alt='Logo' />
        </TopSection>

        <MiddleSection>
          {reportsLhsObject.projects.userType.includes(user?.UserType) && (
            <div id='projectIcon'>
            <IconsWrapper
              type='projects'
              id={reportsLhsObject.projects.id}
              title={reportsLhsObject.projects.title}
              to={reportsLhsObject.projects.href}
              active={activePage === 'projects'}
            >
              <Files />
            </IconsWrapper>
            </div>
          )}

          {reportsLhsObject.userManagement.userType.includes(user?.UserType) && (
            <div id='userManagementIcon'>
            <IconsWrapper
              id={reportsLhsObject.userManagement.id}
              title={reportsLhsObject.userManagement.title}
              to={reportsLhsObject.userManagement.href}
              active={activePage === 'userManagement'}
            >
              <Settings />
            </IconsWrapper>
            </div>
          )}

          {reportsLhsObject.help.userType.includes(user?.UserType) && (
            <div id='helpIcon'>
            <IconsWrapper
              id={reportsLhsObject.help.id}
              title={reportsLhsObject.help.title}
              onClick={() => setShowCanWeHelpModal(true)}
            >
              <Info />
            </IconsWrapper>
            </div>
          )}

          {page === 'reportPage' && ROLES_CLIENT_PRIMARY.includes(user?.UserType) && (
            <PublishProject userType={user.UserType} />
          )}
        </MiddleSection>

        {showCanWeHelpModal && (
          <CanWeHelp
            showButton={false}
            onLoadShow={true}
            onClose={() => {
              setShowCanWeHelpModal(false)
            }}
          />
        )}

        <BottomSection>
          {ROLES_CLIENT_SECONDARY.includes(user.UserType) && <TourGuide type='tutorialButton' />}
          <LayoutHeaderMenu />
        </BottomSection>
      </SidebarContainer>
    </OuterWrapper>
  )
}

export default Sidebar

Sidebar.propTypes = {
  activePage: PropTypes.string,
  onChange: PropTypes.func,
  page: PropTypes.string,
}
